import PropTypes from "prop-types"
import React from "react"

import BaseAvatar from "src/components/BaseAvatar"
import Button from "src/components/Button"

import AuthInterstitialLayout from "./AuthInterstitialLayout"

const GuestSignInNudge = ({
  authPhotoUrl,
  contact,
  onSignIn,
  onSkip,
  signInUrl,
}) => {
  const greetingName = contact.firstName || contact.email

  return (
    <AuthInterstitialLayout
      authPhotoUrl={authPhotoUrl}
      title={greetingName ? `Welcome back ${greetingName}!` : "Welcome back!"}
      subtitle="Your email is already registered. Sign in to make signing your agreement even faster."
    >
      <div className="mx-auto w-full xl:w-3/4">
        <div className="my-6 flex items-center justify-between gap-4 rounded-lg border px-4 py-4 shadow-md">
          <div className="flex items-center gap-3">
            <BaseAvatar
              src={contact.thumbnailUrl}
              name={contact.name}
              backgroundColor={
                contact.thumbnailUrl ? undefined : contact.avatarBackgroundColor
              }
            />
            <div className="flex flex-col">
              <span className="font-semibold text-gray-900">
                {contact.name}
              </span>
              <span className="text-gray-700">{contact.email}</span>
            </div>
          </div>
          <span className="font-semibold text-teal-600">Existing account</span>
        </div>

        <a
          href={signInUrl}
          className="btn btn-primary w-full"
          onClick={onSignIn}
        >
          Sign In
        </a>

        <div className="mt-3">
          <Button variant="link" fullWidth onClick={onSkip}>
            Skip (Not Recommended)
          </Button>
        </div>
      </div>
    </AuthInterstitialLayout>
  )
}

GuestSignInNudge.propTypes = {
  authPhotoUrl: PropTypes.string,
  contact: PropTypes.shape({
    firstName: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    avatarBackgroundColor: PropTypes.string,
  }).isRequired,
  onSignIn: PropTypes.func,
  onSkip: PropTypes.func.isRequired,
  signInUrl: PropTypes.string.isRequired,
}

export default GuestSignInNudge
